export default __webpack_public_path__ + "static/media/invoice-v2.c9031af1.svg";